import { NavLink, Outlet } from 'react-router'
import { UploadDocumentsButton } from '~/features/document-upload'
import { cn } from '~/shared/lib/cn'
import { Alert, IconButton } from '~/shared/ui'
import { useAlertStoreSelectors } from '../model'

const routes = [
  {
    to: '/consignments',
    label: 'Consignments',
  },
  {
    to: '/',
    label: 'Documents',
  },
] as const

export function MainPageSubheader({
  resetDocumentsFilters,
  resetConsignmentsFilters,
}: {
  resetDocumentsFilters: () => void
  resetConsignmentsFilters: () => void
}) {
  const { alertVisible, alertMessage, hideAlert } = useAlertStoreSelectors()

  const onLinkClick = (label: (typeof routes)[number]['label']) => {
    if (label === 'Documents') {
      resetDocumentsFilters()
    } else if (label === 'Consignments') {
      resetConsignmentsFilters()
    }
  }

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <div className="bg-surface-low border-divider relative shrink-0 border-b px-6 pt-3">
        <div className="flex items-center justify-between">
          <h5>Ingested Assets</h5>
          <UploadDocumentsButton />
        </div>
        <div className="-mb-px -ml-4">
          {routes.map((route) => (
            <NavLink
              key={route.to}
              to={route.to}
              onClick={() => onLinkClick(route.label)}
              className={({ isActive }) =>
                cn(
                  'text-text-secondary relative inline-block px-4 py-3 text-sm leading-6 font-medium tracking-[1.25px] uppercase no-underline',
                  'after:bg-primary-main after:absolute after:bottom-0 after:left-0 after:hidden after:h-[2px] after:w-full after:content-[""]',
                  {
                    'text-primary-main after:block': isActive,
                  },
                )
              }
            >
              {route.label}
            </NavLink>
          ))}
        </div>
        {alertVisible && (
          <Alert
            className="absolute top-1/2 right-2.5 min-h-[74px] w-[430px] -translate-y-1/2"
            materialIcon="info"
            appearance="INFO"
            action={
              <IconButton
                className="text-alert-info-message"
                size="medium"
                container="small"
                materialIcon="close"
                onClick={hideAlert}
              />
            }
          >
            {alertMessage}
          </Alert>
        )}
      </div>
      <Outlet />
    </div>
  )
}
